/**
 * Textos do documento do exame dentro da mesa única (E202.F1, GUS-145, ADR-0145): o exame (ou o
 * relatório de risco) como o papel o imprime, com o índice das seções e a prévia em PDF no painel.
 */
export const ptBRDocumentoDaMesa = {
  rotulo: 'Documento do exame',
  saidas: {
    rotulo: 'Documento mostrado',
    exame: 'Exame',
    riscos: 'Relatório de risco',
  },
  carregando: 'Montando o documento…',
  atualizando: 'Atualizando o documento…',
  erro: 'Não foi possível montar o documento. Tente de novo; a prévia em PDF segue no painel.',
  // E206.F3 (GUS-296 item 4): a primeira leitura tenta de novo sozinha; o prazo tem a frase dele.
  esperando:
    'O documento ainda está sendo preparado e aparece aqui quando ficar pronto. A prévia em PDF segue no painel.',
  erroTempo:
    'O documento demorou para ficar pronto. Tente de novo em instantes; a prévia em PDF segue no painel.',
  semDocumento: {
    sem_resultado: 'O documento aparece aqui quando a análise do caso tiver resultado.',
    indisponivel:
      'O documento ainda não pode ser montado nesta etapa do caso. Ele aparece quando a prévia for liberada.',
    nao_aplicavel: 'Este caso não tem relatório de risco.',
    grafotecnica: 'Este caso não tem documento para revisar nesta mesa.',
  },
  assinado:
    'O exame desta análise já foi assinado: o documento abaixo é só para leitura. Mudar o texto agora é uma versão nova, com nova revisão e assinatura.',
  editado: 'Editado',
  editadoNaAnalise: 'Editado na análise {rodada}',
  tirado: 'Trecho tirado do documento',
  riscoTirado: 'Risco tirado do relatório: {texto}',
  alterarNaMesa: 'Alterar na mesa',
  quebra: 'Nova página',
  imagem: 'Imagem do exame',
  indice: 'Seções do exame',
  // E205.F2 (ADR-0147 §2): uma seção por vez na aba Exame, com o índice ao lado.
  secoes: {
    navegacao: 'Navegação entre as seções',
    anterior: 'Anterior',
    proxima: 'Próxima',
    posicao: '{n} de {total}',
    semTitulo: 'Abertura do documento',
    mostrar: 'Seções',
    recolher: 'Recolher as seções',
    // E205.F2.C01 (F-E205.F2-01): a troca espera guardar o rascunho do trecho aberto.
    naoTrocou:
      'A seção não mudou: não foi possível guardar o rascunho do trecho aberto. O texto continua nele; tente de novo ou feche o trecho.',
  },
  // E205.F2: o estado do texto como selo na barra da aba Exame (o porquê fica no `title`).
  selo: {
    rotulo: 'Estado do texto',
    salvo: 'Salvo',
    editando: 'Editando',
    rascunho: 'Rascunho não salvo',
    gravando: 'Gravando…',
    soLeitura: 'Só leitura',
  },
  previaAtualizando: 'Atualizando a prévia… O PDF aparece aqui quando a preparação terminar.',
  // E202.F2 (GUS-145, ADR-0145 §3–§7): a edição no próprio bloco do documento.
  edicao: {
    editar: 'Clique para editar este trecho',
    rascunho: 'Rascunho não salvo',
    emEdicao: 'Em edição, não salvo',
    // E202.F2.C02: o editor só abre com os rascunhos lidos.
    rascunhosFalhou: 'Não foi possível conferir se há rascunho guardado deste trecho.',
    barra: {
      rotulo: 'Formatação do trecho',
      negrito: 'Negrito (Ctrl+B)',
      lista: 'Lista com marcadores',
      desfazer: 'Desfazer (Ctrl+Z)',
      refazer: 'Refazer (Ctrl+Shift+Z)',
    },
    acaoRotulo: 'O que fazer com o trecho',
    fundamento: 'Fundamento da alteração',
    fundamentoAjuda: 'Por que muda (ao menos {minimo} caracteres). Fica no histórico do caso.',
    salvar: 'Salvar',
    salvando: 'Salvando…',
    descartar: 'Descartar',
    fechar: 'Fechar',
    fecharAjuda: 'Esc fecha o trecho; o rascunho fica guardado.',
    semMudanca: 'Altere o texto para salvar.',
    sai: 'Ao salvar, este trecho sai do documento.',
    volta: 'Ao salvar, este trecho volta ao texto original.',
    restaurar: 'Restaurar',
    notaNova: '+ Escrever uma nota nesta seção',
    salva: 'Versão salva. O documento foi atualizado; a prévia em PDF está sendo refeita.',
    naoSalva: 'A versão não foi salva. O texto continua no trecho; tente de novo.',
  },
  // E202.F3 (ADR-0145 §10): a versão do texto e o caminho para a conferência final. E205.F2: a versão
  // foi para o cabeçalho e o botão só fica lá; os motivos viram o `title` do selo e do botão.
  fim: {
    conferir: 'Conferir e assinar',
    pronto: 'O texto está salvo. A conferência final e a assinatura usam esta versão.',
    aberto: 'Salve ou descarte o trecho aberto antes de conferir e assinar.',
    rascunho:
      'Há rascunho não salvo neste documento: salve ou descarte antes de conferir e assinar.',
    // E202.F3.C01: a gravação em curso também segura o encaminhamento.
    salvando: 'Salvando a versão. Conferir e assinar libera quando ela estiver salva.',
  },
  sair: {
    titulo: 'Você tem uma edição não salva',
    texto:
      'O trecho aberto no documento ainda não virou versão salva. O rascunho fica guardado só para você; se descartar, ele se perde.',
    // E203.F2: só o painel do dado tem alteração não salva.
    textoDoPainel: 'O painel do dado tem alteração que ainda não foi salva. Se sair, ela se perde.',
    ficar: 'Ficar na mesa',
    descartar: 'Descartar e sair',
    guardar: 'Guardar o rascunho e sair',
    // E202.F2.C04: sair só depois da confirmação; a falha fica aqui, com o texto no bloco.
    falhouGuardar: 'Não foi possível guardar o rascunho. O texto continua no trecho aberto.',
    falhouDescartar: 'Não foi possível descartar o rascunho. Ele continua guardado.',
  },
  apontado: {
    aberto:
      'A conferência por regras apontou este trecho: ele está aberto no documento, para corrigir.',
  },
  painel: {
    abas: 'O que o painel mostra',
    documentos: 'Documentos',
    previa: 'Prévia (PDF)',
    abrirPrevia: 'Prévia (PDF)',
  },
} as const;
